import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7q 4.5 -3 9 0t 9 0","key":"svg-0"}],["path",{"d":"M3 17q 4.5 -3 9 0q .218 .144 .434 .275","key":"svg-1"}],["path",{"d":"M3 12q 4.5 -3 9 0q 1.941 1.294 3.882 1.472","key":"svg-2"}],["path",{"d":"M19 22v-6","key":"svg-3"}],["path",{"d":"M22 19l-3 -3l-3 3","key":"svg-4"}]]

const IconRippleUp = createReactComponent('outline', 'ripple-up', 'RippleUp', __iconNode);

export default IconRippleUp;